import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";

const SLIDER_LOADING_CLASS = 'loading';

const CONNTECTED_ATTRIBUTE = 'data-connected-select';
const SELECTED_ATTRIBUTE = 'selected';
const DISABLED_ATTRIBUTE = 'disabled';

const SLIDER_SELECTOR = 'div.new-slider';
const SLIDER_SLIDES_SELECTOR = 'ul.slides';
const SLIDER_BUTTONS_SELECTOR = 'ul.buttons';
const SLIDER_LOADER_SELECTOR = 'div.loader-small';
const SVG_AROW_ELEMENT_SELECTOR = 'div.svg-wrapper > svg';

const createNode = ( template ) => {
	const wrapper = document.createElement( 'div' );
	wrapper.innerHTML = template;
	
	return wrapper.firstElementChild;
};

/* Кастыль для сокрытия бокового баннера видеотрансляции */
const fixOldConstructionProgressParts = () => {
	const $oldMain = document.querySelector( 'main.components-container' );
	
	const removeExceed = ( $node ) => {
		if ( $node.children.length === 0 || $node.getBoundingClientRect().height === 0 )
		{
			$node.remove();
		}
	}
	
	if ( $oldMain )
	{
		Array.from( $oldMain.children ).forEach( removeExceed );
		removeExceed( $oldMain );
	}
};

const getMoveBookmarksFunction = ( $bookmarksList ) => {
	const bookmarksLimit = 5;
	const activeBookmarkClass = 'current';
	const $bookmarks = Array.from( $bookmarksList.children );
	
	if ( $bookmarks < bookmarksLimit )
	{
		return () => {};
	}
	
	$bookmarksList.style.overflow = 'hidden';
	
	return () => {
		if ( !$bookmarksList )
		{
			return;
		}
		
		const activeBookmark = $bookmarks.find( ( bookmark ) => bookmark.classList.contains( activeBookmarkClass ) );
		const activeIndex = $bookmarks.findIndex( ( bookmark ) => bookmark === activeBookmark );
		const firstBookmark = $bookmarks[0];
		
		if ( !activeBookmark || !firstBookmark )
		{
			return;
		}
		
		const lastBookmarkIndex = $bookmarks.length - 1;
		const bookmarkStyle = firstBookmark.currentStyle || window.getComputedStyle( firstBookmark );
		const bookmarkWidth = firstBookmark.offsetWidth;
		const bookmarkMargin = parseFloat( bookmarkStyle.marginRight );
		
		const calculateWidth = ( bookmarkCount ) => {
			return ( bookmarkWidth + bookmarkMargin ) * bookmarkCount;
		};
		
		const setOffset = ( offset ) => {
			firstBookmark.style.marginLeft = `-${offset}px`;
		};
		
		const setMaxWidth = ( maxWidth ) => {
			$bookmarksList.style.maxWidth = `${maxWidth}px`;
		};
		
		setMaxWidth( calculateWidth( bookmarksLimit ) - bookmarkMargin );
		
		if ( activeIndex === 0 || activeIndex === 1 || activeIndex === 2 )
		{
			setOffset( 0 );
		}
		else if ( activeIndex === lastBookmarkIndex || activeIndex === ( lastBookmarkIndex - 1 ) || activeIndex === ( lastBookmarkIndex - 2 ) )
		{
			setOffset( calculateWidth( $bookmarks.length - bookmarksLimit ) );
		}
		else
		{
			setOffset( calculateWidth( activeIndex - 2 ) );
		}
	};
};

const initSliderScripts = ( $slider ) => {
	const $slides = Array.from( $slider.querySelectorAll( `${SLIDER_SLIDES_SELECTOR} > li` ) );
	
	convertOldDataToNewSlider( $slider );
	
	if ( $slides.length === 0 )
	{
		return;
	}
	
	const bookmarksListTemplate = (`
		<ul class="bookmarks" data-slider-role="bookmarks">
			${$slides.map( () => '<li></li>' ).join( '' )}
		</ul>
	`);
	
	const $bookmarksList = createNode( bookmarksListTemplate );
	
	if ( $bookmarksList && $slides.length > 1 )
	{
		$slider.appendChild( $bookmarksList );
	}
	
	const switchCallback = getMoveBookmarksFunction( $bookmarksList );
	
	const bookmarks = $slider.querySelector( 'ul.bookmarks' );
	const btnNext = $slider.querySelector( '.swiper-button-next' );
	const btnPrev = $slider.querySelector( '.swiper-button-prev' );

	const swiper = new Swiper( $slider, {
		slidesPerView: 'auto',
		modules: [Navigation, Pagination],
		navigation: {
			disabledClass: 'disabled',
			nextEl: btnNext,
			prevEl: btnPrev,
		},
		pagination: {
			el: bookmarks,
			clickable: true,
			noSwiping: true,
			bulletActiveClass: 'current',
			renderBullet: function ( index, className ) {
				return `<li class="${className}"></li>`;
			},
		},
	} );
	
	switchCallback();
	
	const $firstImg = $slides[0]?.querySelector( 'img' );
	
	if ( $firstImg )
	{
		const loadImgHandler = () => {
			if ( $firstImg.complete && $firstImg.naturalHeight && $firstImg.naturalWidth )
			{
				$slider.classList.remove( SLIDER_LOADING_CLASS );
			}
			else
			{
				$firstImg.addEventListener( 'load', loadImgHandler );
			}
		};
		
		loadImgHandler();
	}
};

const convertOldDataToNewSlider = ( $slider ) => {
	$slider.querySelectorAll( `${SLIDER_SLIDES_SELECTOR} > li` ).forEach( ( $slideWrapper ) => {
		const $figcaption = $slideWrapper.querySelector( 'figure > figcaption' );
		
		if ( $figcaption )
		{
			$figcaption.remove();
		}
		
		$slideWrapper.removeAttribute( 'oncontextmenu' );
	} );
};

const createLastSlide = ( dateLabel, dateValue, $component, $controlForm ) => {
	const $svgArrow = $component.querySelector( SVG_AROW_ELEMENT_SELECTOR );
	
	const lastSlideButtonClass = 'prev-month';
	const dateAttribute = 'data-date-value';
	
	const template = (`
		<li class="swiper-slide">
			<button class="${lastSlideButtonClass}" type="button" ${dateAttribute}="${dateValue}">
				<span class="label">
					${$svgArrow?.outerHTML}
					${$svgArrow?.outerHTML}
				</span>
				<span class="info">
					<span class="title">Предыдущий месяц</span>
					<span class="date">${dateLabel}</span>
				</span>
			</button>
		</li>
	`);
	
	const $lastSlide = createNode( template );
	
	const $lastButton = $lastSlide.querySelector( `button.${lastSlideButtonClass}` );
	
	const handleLastButtonClick = () => {
		const $dateSelect = $controlForm.querySelector( 'select#yyyy_mm' );
		
		if ( $dateSelect )
		{
			$dateSelect.value = dateValue;
			
			$dateSelect.querySelectorAll( `option:not( [${DISABLED_ATTRIBUTE}] )` ).forEach( ( $option ) => {
				if ( $option.value === dateValue )
				{
					$option.setAttribute( SELECTED_ATTRIBUTE, '' );
				}
				else
				{
					$option.removeAttribute( SELECTED_ATTRIBUTE );
				}
			} );
		}
		
		updateSlides( $component, $controlForm );
	};
	
	/* Отменяет стандартное действие при клике на кнопку, если вызывалось событие mousemove */
	const canselInteractivity = ( clickEvt ) => {
		clickEvt.preventDefault();
		clickEvt.stopPropagation();
		clickEvt.stopImmediatePropagation();
		
		$lastButton.removeEventListener( 'click', canselInteractivity, true );
	};
	
	$lastButton.addEventListener( 'mousedown', ( downEvt ) => {
		const startX = downEvt.x;
		
		const handleMoveEvt = ( moveEvt ) => {
			const offset = startX - moveEvt.x;
			
			if ( Math.abs( offset ) > 1 )
			{
				$lastButton.addEventListener( 'click', canselInteractivity, true );
			}
		};
		
		const handleEndEvt = () => {
			document.removeEventListener( `mousemove`, handleMoveEvt );
			document.removeEventListener( `mouseup`, handleEndEvt );
		};
		
		document.addEventListener( `mousemove`, handleMoveEvt );
		document.addEventListener( `mouseup`, handleEndEvt );
		
		$lastButton.removeEventListener( 'click', canselInteractivity, true );
	}, true );
	
	$lastButton.addEventListener( 'click', handleLastButtonClick );
	
	return $lastSlide;
};

const createSliderNode = ( listItemsTemplate ) => {
	const template = (`
		<div class="new-slider loading swiper-construction">
			<ul class="slides swiper-wrapper">
				${listItemsTemplate}
			</ul>
		</div>
	`);
	
	return createNode( template );
};

const updateSlides = ( $component, $controlForm ) => {
	$component.querySelector( SLIDER_SELECTOR )?.classList?.add( SLIDER_LOADING_CLASS );
	
	const title = document.querySelector( 'head title' )?.textContent;
	const query = `?${
		Array.from( $controlForm.querySelectorAll( 'select' ) )
			.map( ( $node ) => {
				return `${$node.getAttribute( 'name' )}=${$node.value}`;
			} )
			.join( '&' )
	}`;
	
	window.history.pushState( null, title, query );
	
	const serializeRequest = Array.from( $controlForm.querySelectorAll('input, select') )
		.map( ( item ) => {
			const name = item.name;
			const value = item.value;
			
			if ( name && value )
			{
				return `${name}=${value}`;
			}
			
			return '';
		} )
		.join( '&' );
	
	fetch(
		$controlForm.getAttribute( 'action' ),
		{
			method: 'POST',
			cache: 'no-cache',
			credentials: 'same-origin',
			body: serializeRequest,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			referrerPolicy: 'no-referrer'
		}
	)
		.then( ( response ) => response.json() )
		.then( ( msg ) => {
			const data = msg.construction_progress_component;
			
			const $newSlider = createSliderNode( data.ri );
			const $newSlidesList = $newSlider.querySelector( SLIDER_SLIDES_SELECTOR );
			
			/* Добавляется последний слайд-кнопка перехода на предыдущий месяц */
			if ( data.selected_guid_building && data.selected_yyyy_mm )
			{
				const dates = data['yyyy_mm'][data.selected_guid_building];
				const newDateInfoIndex = dates.findIndex( ( dateInfo ) => dateInfo.value === data.selected_yyyy_mm );
				
				if ( newDateInfoIndex > 0 )
				{
					const newDateInfo = dates[newDateInfoIndex - 1];
					
					if ( $newSlidesList )
					{
						const $lastSlide = createLastSlide( newDateInfo.text, newDateInfo.value, $component, $controlForm );
						$newSlidesList.appendChild( $lastSlide );
					}
				}
			}
			
			const $slider = $component.querySelector( SLIDER_SELECTOR );
			
			if ( $slider )
			{
				const $sliderButtonsList = $slider.querySelector( SLIDER_BUTTONS_SELECTOR );
				
				if ( $sliderButtonsList )
				{
					const $newsliderButtonsList = $sliderButtonsList.cloneNode( true );
					$newsliderButtonsList.classList.remove( 'show' );
					
					$newSlider.appendChild( $newsliderButtonsList );
				}
				
				const $loader = $slider.querySelector( SLIDER_LOADER_SELECTOR );
				
				if ( $loader )
				{
					$loader.cloneNode( true );
					
					$newSlider.appendChild( $loader );
				}
				
				$slider.replaceWith( $newSlider );
			}
			
			initSliderScripts( $newSlider );
		} );
};

const initControlForm = ( $component, $controlForm, $allDatesOptions ) => {
	$controlForm.addEventListener( 'change', ( evt ) => {
		const $select = evt.target.closest( 'select' );
		
		if ( !$select )
		{
			return;
		}
		
		$select.querySelectorAll( `option:not( [${DISABLED_ATTRIBUTE}] )` ).forEach( ( $option ) => {
			if ( $option.value === $select.value )
			{
				$option.setAttribute( SELECTED_ATTRIBUTE, '' );
			}
			else
			{
				$option.removeAttribute( SELECTED_ATTRIBUTE );
			}
		} );
		
		const connectedName = $select.getAttribute( CONNTECTED_ATTRIBUTE );
		
		/* Связывает выбранный корпус с доступными месяцами */
		if ( connectedName )
		{
			const name = $select.name;
			const value = $select.value;
			const $connectedSelect = $controlForm.querySelector( `select#${connectedName}` );
			
			if ( $connectedSelect )
			{
				const currentSelectedOption = $allDatesOptions.find( ( $option ) => $option.hasAttribute( SELECTED_ATTRIBUTE ) )?.value;
				const $newOptions = [];
				
				for ( let $option of $allDatesOptions )
				{
					$option.removeAttribute( DISABLED_ATTRIBUTE );
					$option.removeAttribute( SELECTED_ATTRIBUTE );
					
					if ( $option.getAttribute( `data-${name}` ) === value )
					{
						$newOptions.push( $option );
					}
				}
				
				const $suitableOption = $newOptions.find( ( $option ) => $option.value === currentSelectedOption );
				
				/* Если у корпуса нет выбраного ранее месяца, то показывается последний из доступных */
				if ( $suitableOption )
				{
					$suitableOption.setAttribute( SELECTED_ATTRIBUTE, '' );
				}
				else
				{
					$newOptions[$newOptions.length - 1]?.setAttribute( SELECTED_ATTRIBUTE, '' );
				}
				
				const fragment = new DocumentFragment();
				for ( let $option of $newOptions )
				{
					fragment.append( $option );
				}
				$connectedSelect.innerHTML = '';
				$connectedSelect.append( fragment );
			}
		}
		
		updateSlides( $component, $controlForm );
	} );
};

const adjustButtonsHeight = ( $component ) => {
	const $sliderContainer = $component.querySelector( SLIDER_SELECTOR );
	const $sliderButtons = $sliderContainer?.querySelectorAll( 'ul.buttons > li' );
	
	if ( $sliderContainer && $sliderButtons )
	{
		$sliderButtons.forEach( ( $sliderButton ) => {
			$sliderButton.style.top = `${$sliderContainer.offsetHeight / 2}px`;
		} );
	}
};

const initConstructionProgress = () => {
	document.querySelectorAll( 'section.cds2-construction-progress' ).forEach( ( $component ) => {
		
		/* TODO: УБРАТЬ перемещение в другой поток */
		// const newMainSelector = 'main.new-components-container';
		// if ( !$component.closest( newMainSelector ) )
		// {
		// 	document.querySelector( newMainSelector ).appendChild( $component );
		// }
		
		// fixOldConstructionProgressParts();
		
		let $slider = $component.querySelector( SLIDER_SELECTOR );
		const $controlForm = $component.querySelector( 'form.controls' );
		
		if ( !$slider || !$controlForm )
		{
			return;
		}
		
		const $slides_list = $slider.querySelector( SLIDER_SLIDES_SELECTOR );
		
		/* Добавляем последний слайд-кнопку перехода на предыдущий месяц */
		const $dateSelect = $controlForm.querySelector( 'select#yyyy_mm' );
		if ( !$dateSelect )
		{
			return
		}
		
		const $allDatesOptions = Array.from( $dateSelect.options );
		const $datesOptions = [];
		let selectedOptionIndex = 0;
		
		$allDatesOptions.forEach( ( $option, index ) => {
			if ( $option.hasAttribute( DISABLED_ATTRIBUTE ) )
			{
				$option.remove();
			}
			else
			{
				$datesOptions.push( $option );
				
				if ( $option.hasAttribute( SELECTED_ATTRIBUTE ) )
				{
					selectedOptionIndex = $datesOptions.length - 1;
				}
			}
		} );
		
		if ( selectedOptionIndex > 0 )
		{
			const newDateInfo = $datesOptions[selectedOptionIndex - 1];
			const $lastSlide = createLastSlide( newDateInfo.textContent, newDateInfo.value, $component, $controlForm );
			
			$slides_list.appendChild( $lastSlide );
		}
		
		initSliderScripts( $slider );
		
		initControlForm( $component, $controlForm, $allDatesOptions );
		
		const resizeHandler = adjustButtonsHeight.bind( null, $component );
		window.addEventListener( 'resize', resizeHandler );
		adjustButtonsHeight( $component );
	} );
};

export {
	initConstructionProgress,
}
